/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { createObservableDataAction, IAction, ICreateActionContext } from '@msdyn365-commerce/core';
import { retailAction } from '@msdyn365-commerce/retail-proxy';
import { IRoof } from './DataServiceEntities.g';
import { createGetRoofTableInput } from './DataActionExtension.g';

export default createObservableDataAction({
    action: <IAction<IRoof[]>>retailAction,
    input: (context: ICreateActionContext) => {
        return createGetRoofTableInput({ Paging: { Top: 0 } });
    }
});
